var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import Controls from './components/Controls';
import Layout from './components/Layout';
import createTime from './utils/time';
var UNKNOWN_WIDTH = -1;
var Timeline = /** @class */ (function (_super) {
    __extends(Timeline, _super);
    function Timeline(props) {
        var _this = _super.call(this, props) || this;
        _this.handleLayoutChange = function (settings, cb) {
            var _a = settings.timelineViewportWidth, timelineViewportWidth = _a === void 0 ? UNKNOWN_WIDTH : _a, _b = settings.sidebarWidth, sidebarWidth = _b === void 0 ? UNKNOWN_WIDTH : _b;
            var scale = _this.props.scale;
            var time = createTime(__assign(__assign({}, scale), { viewportWidth: timelineViewportWidth }));
            _this.setState({
                time: time,
                timelineViewportWidth: timelineViewportWidth,
                sidebarWidth: sidebarWidth,
            }, cb);
        };
        var timelineViewportWidth = UNKNOWN_WIDTH;
        var sidebarWidth = UNKNOWN_WIDTH;
        _this.state = {
            time: createTime(__assign(__assign({}, props.scale), { viewportWidth: timelineViewportWidth })),
            timelineViewportWidth: timelineViewportWidth,
            sidebarWidth: sidebarWidth,
        };
        return _this;
    }
    // eslint-disable-next-line camelcase
    Timeline.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var scale = this.props.scale;
        var timelineViewportWidth = this.state.timelineViewportWidth;
        if (nextProps.scale !== scale) {
            var time = createTime(__assign(__assign({}, nextProps.scale), { viewportWidth: timelineViewportWidth }));
            this.setState({ time: time });
        }
    };
    Timeline.prototype.render = function () {
        var _a = this.props, _b = _a.isOpen, isOpen = _b === void 0 ? true : _b, toggleOpen = _a.toggleOpen, zoomIn = _a.zoomIn, zoomOut = _a.zoomOut, _c = _a.scale, zoom = _c.zoom, zoomMin = _c.zoomMin, zoomMax = _c.zoomMax, tracks = _a.tracks, now = _a.now, timebar = _a.timebar, toggleTrackOpen = _a.toggleTrackOpen, _d = _a.enableSticky, enableSticky = _d === void 0 ? false : _d, scrollToNow = _a.scrollToNow;
        var _e = this.state, time = _e.time, timelineViewportWidth = _e.timelineViewportWidth, sidebarWidth = _e.sidebarWidth;
        var _f = this.props, clickElement = _f.clickElement, clickTrackButton = _f.clickTrackButton;
        return (_jsxs("div", __assign({ className: "rt" }, { children: [_jsx(Controls, { isOpen: isOpen, toggleOpen: toggleOpen, zoomIn: zoomIn, zoomOut: zoomOut, zoom: zoom, zoomMin: zoomMin, zoomMax: zoomMax }), _jsx(Layout, { enableSticky: enableSticky, now: now, tracks: tracks, timebar: timebar, toggleTrackOpen: toggleTrackOpen, scrollToNow: scrollToNow, time: time, isOpen: isOpen, onLayoutChange: this.handleLayoutChange, timelineViewportWidth: timelineViewportWidth, sidebarWidth: sidebarWidth, clickElement: clickElement, clickTrackButton: clickTrackButton })] })));
    };
    return Timeline;
}(Component));
export default Timeline;
